export const LOCAL_TYPE = 'local';
export const LDAP_TYPE = 'ldap';
export const SAML_TYPE = 'saml';
export const STORAGE_USERNAME = 'username';
export const PENDING = 'pending';
export const NC_DEFAULT_VERSION = 'master';
